import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'components';
import * as actions from '../../../redux/actions';
import { history } from 'routers/AppRouter';
import * as routes from '../../../settings/_routesSettings';

const Processing = ({ order, user, planSelected, generateOrder }) => { 
  useEffect(() => {
    if (!order) return;
    
    const handleOrder = () => {
      const newOrder = order;
      if (!newOrder.plan_code) newOrder.plan_code = planSelected ? planSelected.partner_plan_code : null;

      if (newOrder.plan_code === 'PLN01000') generateOrder(newOrder, user);
      else history.push(routes.DASHBOARD_APPOINTMENTS);
    };

    handleOrder();
  }, [ order, user, planSelected, generateOrder ]);

  return (
    <div className="Processing">
      <Spinner height='30vh' />
    </div>
  );
};

const mapStateToProps = state => ({
  order: state.orders.order,
  user: state.auth.userData,
  planSelected: state.auth.planSelected,
});

const mapDispatchToProps = dispatch => ({ generateOrder: (order, user) => dispatch(actions.generateOrder(order, user)) });

export default connect(mapStateToProps, mapDispatchToProps)(Processing);